import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Shared privacy notice + required consent checkbox for lead forms.
 */
const FormPrivacyNotice = ({ checked, onChange, id = 'privacy-consent', className = '' }) => (
  <div className={`space-y-2 ${className}`}>
    <label htmlFor={id} className="flex cursor-pointer items-start gap-2.5 text-left text-xs leading-relaxed text-neutral-600">
      <input
        id={id}
        type="checkbox"
        required
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-4 w-4 shrink-0 rounded border-neutral-300 text-primary focus:ring-primary"
      />
      <span>
        I agree to PetCart contacting me about this enquiry and to the processing of my details as
        described in the{' '}
        <Link to="/privacy-policy" className="font-semibold text-primary underline-offset-2 hover:underline">
          Privacy Policy
        </Link>
        .
      </span>
    </label>
  </div>
);

export default FormPrivacyNotice;
